<template>
  <div>
    <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
    <v-container>
      <v-layout>
        <v-flex class="ml-2" xs2>
          <v-menu
            ref="menu"
            v-model="menu"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                :rules="rules.required"
                v-model="startDate"
                :label="$t('employerReports.startDate')"
                prepend-icon="event"
                readonly
                v-on="on"
                class="fixed-height-textfield"
                outline
              ></v-text-field>
            </template>
            <v-date-picker
              color="primary"
              v-model="startDate"
              @input="menu = false"
              :max="today"
              :locale="$t('reportsType.local')">
              <v-spacer></v-spacer>
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex class="ml-2" xs2>
          <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="true"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
              :rules="rules.required"
                v-model="endDate"
                :label="$t('employerReports.endDate')"
                prepend-icon="event"
                readonly
                v-on="on"
                class="fixed-height-textfield"
                outline
              ></v-text-field>
            </template>
            <v-date-picker
              color="primary"
              v-model="endDate"
              :min="startDate"
              :max="today"
              :locale="$t('reportsType.local')"
              @input="menu = false"
              @change="dateVerify()"
            >
              <v-spacer></v-spacer>
            </v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex class="ml-2" xs3>
          <v-select v-model="selectedEmployee" :items="employees" :rules="rules.required" :label="$t('expenseDetailEmployee.employee')" class="fixed-height"  item-text="name" item-value="id" solo></v-select>
        </v-flex>
        <v-flex class="ml-2" xs2>
          <v-select v-model="selectedStatus" :items="status" :rules="rules.required" :label="$t('general.status')" class="fixed-height" item-text="text" item-value="value" solo></v-select>
        </v-flex>
        <v-flex class="ml-2" xs3>
          <v-select v-model="selectedProject" :items="projects" :rules="rules.required" :label="$t('general.projects')" class="fixed-height"  item-value="id" item-text="name" solo>
            <template slot="item" slot-scope="data">
              {{ data.item.name }} - {{ data.item.status === 1 ? $t('projects.stat.active') : $t('projects.stat.inactive')}}
            </template>
            <template v-slot:selection="{ item }">
              <div class="ellipsis-2-lines" style="-webkit-box-orient: vertical !important;" :title="item.name">
                {{ item.name }}
              </div>
            </template>
          </v-select>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex class="ml-2" xs5>
          <v-text-field v-model="searchReport" :label="$t('general.search')" clearable append-outer-icon="search"></v-text-field>
        </v-flex>
        <v-flex class="ml-2" xs2>
          <v-btn @click="getAdvances(typeRequest = 1)" :disabled="loading" :loading="loading" round depressed color="primary">
            <v-icon>search</v-icon>
            {{ $t('general.search') }}
          </v-btn>
        </v-flex>
        <v-flex class="text-sm-right">
          <v-btn color="primary" round outline :loading="downloadLoading" @click="getAdvances(typeRequest = 2)">
            {{$t('expenseDetailEmployee.download')}}
            <v-icon right>cloud_download</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
      <v-layout v-if="loadingItems">
        <v-flex>
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
          <span>{{$t('general.loadingText')}}</span>
        </v-flex>
      </v-layout>
      <v-layout class="mt-3" v-if="loadingItems === false">
        <v-flex>
          <v-data-table
            :search="searchReport"
            :headers="headers"
            :items="items"
            :loading="loadingItems"
            class="elevation-1"
            :rows-per-page-items="[10,15,25]"
            :no-data-text="$t('expenseDetailEmployee.noResults')"
            :sort-by.sync="pagination.sortBy"
            :sort-desc.sync="pagination.descending"
            :pagination.sync="pagination"
            >
            <template v-slot:headers="props">
              <tr class="bg-heavy-rain">
                <th v-for="header in props.headers"
                  :key="header.text"
                  :style="header.hidden ? 'display: none;' : ''"
                  :class="['text-center', 'column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                  @click="changeSort(header)">
                  <span class="font-weight-black primary--text mb-0" style="font-size:14px">
                    <v-icon small class="primary--text" v-if="header.sortable">
                      arrow_upward
                    </v-icon>
                    {{ header.text }}
                  </span>
                </th>
              </tr>
            </template>
            <template v-slot:items="props">
              <tr>
                <td class="text-center">{{ props.item.request_folio }}</td>
                <td class="text-center">{{ props.item.request_creation_date }}</td>
                <td class="text-center">{{ props.item.assigned_user_name ? props.item.assigned_user_name : props.item.request_user_name }}</td>
                <td class="text-center">{{ props.item.request_status }}</td>
                <td class="text-center">{{ props.item.request_start_date }}</td>
                <td class="text-center">{{ props.item.request_end_date }}</td>
                <td class="text-center">{{ props.item.project_name }}</td>
                <td class="text-center">{{ props.item.request_total | formatCurrency }}</td>
                <td class="text-center text-no-wrap">
                  <v-tooltip class="ma-0 pa-0" bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn class="ma-0 pa-0" small outline icon color="info" v-on="on" @click="showRequestDetail(props.item)">
                        <v-icon small>mdi-eye</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('general.seeMore') }}</span>
                  </v-tooltip>
                  <v-tooltip class="ma-0 pa-0" bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        class="ma-0 ml-1 pa-0"
                        small
                        outline
                        icon
                        color="error"
                        :loading="isDownloadingRequest(props.item.request_folio, 'pdf')"
                        :disabled="!!downloadingRequest"
                        v-on="on"
                        @click="downloadRequest({ folio: props.item.request_folio, type: 'pdf' })"
                      >
                        <v-icon small>mdi-file-pdf-box</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('viatics.downloadRequest') }} PDF</span>
                  </v-tooltip>
                  <v-tooltip class="ma-0 pa-0" bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn
                        class="ma-0 ml-1 pa-0"
                        small
                        outline
                        icon
                        color="green"
                        :loading="isDownloadingRequest(props.item.request_folio, 'xls')"
                        :disabled="!!downloadingRequest"
                        v-on="on"
                        @click="downloadRequest({ folio: props.item.request_folio, type: 'xls' })"
                      >
                        <v-icon small>mdi-file-excel-box</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('viatics.downloadRequest') }} Excel</span>
                  </v-tooltip>
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>

      <request-detail-dialog
        v-model="requestDetailDialog"
        :request="selectedRequest"
        :catalogs="requestCatalogs"
        :loading="loadingRequestDetail"
        :downloading="detailDownloadingType"
        readonly
        @view-file="showFile"
        @download="downloadRequestFromDetail"
      />

      <file-viewer-dialog
        v-model="fileViewerDialog"
        :file-id="viewedFile.id"
        :file-type-id="viewedFile.typeId"
        :data-url="dataURLFile"
        :loading="loadFile"
        :downloading="loadBtn"
        @download="downloadCompressedFile"
        @close="closeFileViewer"
      />
    </v-container>
  </div>
</template>

<script>
import RequestDetailDialog from './requests/RequestDetailDialog.vue'
import FileViewerDialog from './requests/FileViewerDialog.vue'
import { isCompressedFile } from './requests/request.model'

export default {
  name: 'advancesRequestComponent',
  components: { RequestDetailDialog, FileViewerDialog },
  data () {
    return {
      items: [],
      requestDetailDialog: false,
      selectedRequest: null,
      loadingRequestDetail: false,
      // Los llenan validators/getValidatorsByCompany y approver/get_users (mismas mutaciones que reservations).
      validatorsRequest: [],
      users: [],
      // Visor de adjuntos. dataURL / dataURLFile / loadFile / loadBtn son los nombres
      // que escriben las mutaciones raíz onGetFile y onGetZip.
      // Descarga en curso con la forma "<folio>:<pdf|xls>"; vacío si no hay ninguna.
      downloadingRequest: '',
      fileViewerDialog: false,
      viewedFile: { id: null, typeId: null },
      dataURL: null,
      dataURLFile: null,
      loadFile: false,
      loadBtn: false,
      pagination: {
        sortBy: 'request_folio',
        descending: true,
        page: 1,
        rowsPerPage: 15, // -1 for All",
        totalItems: 0
      },
      menu: false,
      menu2: false,
      projects: [],
      employees: [],
      dialog: false,
      userLogged: {},
      downloadLoading: false,
      loading: false,
      switch1: false,
      searchReport: '',
      loadingItems: true,
      selectedStatus: -1,
      selectedProject: null,
      selectedEmployee: null,
      switchAllStatus: true,
      switchAllDates: false,
      switchAllProjects: true,
      switchAllEmployees: true,
      today: new Date().toISOString().substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      startDate: '',
      typeRequest: 1
    }
  },
  created () {
    let vr = new Date()
    vr.setDate(vr.getDate() - 30)
    this.startDate = vr.toISOString().substr(0, 10)
    this.getLogged()
    this.getAdvances(this.typeRequest = 1)
  },
  watch: {
    '$store.state.userLogged' () {
      this.getLogged()
    },
    employees () {
      if (this.employees !== undefined && this.employees.find(x => x.id === -1) === undefined) {
        let objDefault = { id: -1, name: this.$t('expenseDetailEmployee.allEmployees') }
        this.selectedEmployee = -1
        this.employees.unshift(objDefault)
      }
    },
    projects () {
      if (this.projects !== undefined && this.projects.find(x => x.id === -1) === undefined) {
        let objDefault = { id: -1, name: this.$t('expenseDetailEmployee.allProjects') }
        this.selectedProject = -1
        this.projects.unshift(objDefault)
      }
    }
  },
  computed: {
    status () {
      return [
        {
          text: this.$t('expenseDetailEmployee.allStatus'),
          value: -1
        },
        {
          text: this.$t('general.requestStatus.created'),
          value: 'CREATED'
        },
        {
          text: this.$t('general.requestStatus.sent'),
          value: 'SENT'
        },
        {
          text: this.$t('general.requestStatus.in_review'),
          value: 'IN_REVIEW'
        },
        {
          text: this.$t('general.requestStatus.approved'),
          value: 'APPROVED'
        },
        {
          text: this.$t('general.requestStatus.rejected'),
          value: 'REJECTED'
        }
      ]
    },
    /** Tipo ('pdf' | 'xls') que se está descargando de la solicitud abierta en el modal. */
    detailDownloadingType () {
      let request = this.selectedRequest || {}
      let folio = request.folio || request.request_folio
      let prefix = folio + ':'
      return folio && this.downloadingRequest.indexOf(prefix) === 0
        ? this.downloadingRequest.slice(prefix.length)
        : ''
    },
    /** Catálogos del modal de detalle: usuarios (asignado) y validadores. */
    requestCatalogs () {
      return {
        users: (this.users || [])
          .filter(user => user && user.id !== undefined && user.id !== null)
          .map(user => ({ id: user.id, name: user.name || '' })),
        validators: (this.validatorsRequest || [])
          .filter(validator => validator && validator.id !== undefined && validator.id !== null)
          .map(validator => ({
            id: validator.id,
            name: validator.user && validator.user.name ? validator.user.name : ''
          }))
      }
    },
    heading () {
      return this.$t('helpDrawer.advancesRequest.title') 
    },
    subheading () {
      return ''
    },
    icon () {
      return 'far fa-file-alt fa-fw icon-color'
    },
    rules () {
      return this.$validationRules()
    },
    headers () {
      return [
        {
          text: this.$t('general.folio'),
          align: 'center',
          value: 'request_folio',
          sortable: true
        },
        {
          text: this.$t('general.date'),
          align: 'center',
          value: 'request_creation_date',
          sortable: true
        },
        {
          text: 'requester',
          align: 'center',
          value: 'assigned_user_name',
          hidden: true
        },
        {
          text: this.$t('viatics.requester'),
          align: 'center',
          value: 'request_user_name',
          sortable: true
        },
        {
          text: this.$t('conciliation.statusLabel'),
          align: 'center',
          value: 'request_status',
          sortable: true
        },
        {
          text: this.$t('viatics.dateStart'),
          align: 'center',
          value: 'request_start_date',
          sortable: true
        },
        {
          text: this.$t('viatics.dateEnd'),
          align: 'center',
          value: 'request_end_date',
          sortable: true
        },
        {
          text: this.$t('general.project'),
          align: 'center',
          value: 'project_name',
          sortable: true
        },
        {
          text: this.$t('general.amountRequest'),
          align: 'center',
          value: 'request_total',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          align: 'center',
          value: 'actions',
          sortable: false
        }
      ]
    }
  },
  methods: {
    getLogged () {
      if (this.$store.state.userLogged.company) {
        this.userLogged = this.$store.state.userLogged
        this.getEmployees()
        this.get()
      }
    },
    get () {
      this.$emit('get', {company_id: this.userLogged.company[0].id, context: this})
    },
    getEmployees () {
      this.companyId = this.userLogged.company[0].id
      this.$emit('getEmployees', {
        context: this,
        item: {
          companyId: this.companyId
        }
      })
    },
    getAdvances (item) {
      this.downloadLoading = item !== 1
      this.$emit('getAdvances', {
        context: this,
        data: {
          startDate: this.startDate,
          endDate: this.endDate,
          requestStatus: this.selectedStatus === -1 ? null : this.selectedStatus,
          userId: this.selectedEmployee === -1 ? null : this.selectedEmployee,
          projectId: this.selectedProject === -1 ? null : this.selectedProject,
          typeRequest: item,
          type: item === 1 ? 'json' : 'download'
        }
      })
    },
    close () {
      this.dialog = false
    },
    downloadRequest ({ folio, id, type }) {
      if (!folio || this.downloadingRequest) return
      this.downloadingRequest = `${folio}:${type}`
      this.$emit('downloadRequest', {
        context: this,
        data: { folio, id: id || null, type }
      })
    },
    downloadRequestFromDetail ({ type, request }) {
      this.downloadRequest({ folio: request.folio, id: request.id, type })
    },
    isDownloadingRequest (folio, type) {
      return this.downloadingRequest === `${folio}:${type}`
    },
    showFile (attachment) {
      const fileId = attachment ? attachment.fileId : null
      if (!fileId) return

      this.viewedFile = { id: fileId, typeId: attachment.fileTypeId }
      this.dataURL = null
      this.dataURLFile = null
      this.loadFile = true
      this.fileViewerDialog = true
      this.requestFile(fileId)
    },
    downloadCompressedFile () {
      this.loadBtn = true
      this.requestFile(this.viewedFile.id)
    },
    requestFile (fileId) {
      // Los comprimidos se descargan; el resto se muestra dentro del visor.
      const action = isCompressedFile(this.viewedFile.typeId) ? 'getZip' : 'getFile'
      this.$emit(action, { context: this, fileId })
    },
    closeFileViewer () {
      this.fileViewerDialog = false
      this.viewedFile = { id: null, typeId: null }
      this.dataURL = null
      this.dataURLFile = null
      this.loadFile = false
      this.loadBtn = false
    },
    showRequestDetail (item) {
      // Se pinta de inmediato lo que ya trae la tabla y se refresca con el endpoint.
      this.selectedRequest = item
      this.requestDetailDialog = true
      this.loadingRequestDetail = true
      if (this.validatorsRequest.length === 0) {
        this.$emit('getValidatorsByCompany', { context: this })
      }
      if (this.users.length === 0) {
        this.$emit('getUsers', { context: this })
      }
      this.$emit('getRequestDetail', {
        context: this,
        data: {
          folio: item.request_folio
        }
      })
    },
    filter () {
        this.loading = true
        if (this.switchAllEmployees) this.selectedEmployee = null
        if (this.switchAllStatus) this.selectedStatus = null
        if (this.switchAllProjects) this.selectedProject = null
        this.getAdvances(this.typeRequest = 1)
    },
    changeSort (header) {
      if (header.sortable) {
        if (this.pagination.sortBy === header.value) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.descending = false
        }
        this.pagination.sortBy = header.value
      } else {
        this.pagination.sortBy = ''
      }
    }
  }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/advancesRequest.component.vue